import React, { useEffect } from 'react';
import Box from '@mui/material/Box';

/**
 * Minimal open HTML editor for town portal emails (blank start, full-body editable).
 */
const TownPortalEmailEditor = ({ emailBody, onContentChange }) => {
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data?.type === 'townPortalContentChange') {
        onContentChange(event.data.content);
      }
    };
    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [onContentChange]);

  return (
    <Box
      sx={{
        flex: 1,
        minHeight: 360,
        border: '1px solid #dadce0',
        borderRadius: 1,
        overflow: 'hidden',
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <iframe
        key={emailBody}
        title="Town Portal Email Editor"
        srcDoc={`
          <!DOCTYPE html>
          <html>
          <head>
            <meta charset="UTF-8">
            <style>
              html, body { height: 100%; margin: 0; }
              body {
                font-family: Arial, sans-serif;
                font-size: 14px;
                line-height: 1.6;
                color: #202124;
                padding: 16px;
                box-sizing: border-box;
                min-height: 100%;
              }
            </style>
          </head>
          <body contenteditable="true">${emailBody || '<p><br></p>'}</body>
          <script>
            document.body.addEventListener('input', function() {
              if (window.parent && window.parent.postMessage) {
                window.parent.postMessage({
                  type: 'townPortalContentChange',
                  content: document.body.innerHTML
                }, '*');
              }
            });
          </script>
          </html>
        `}
        style={{ width: '100%', height: '100%', border: 'none', flex: 1, minHeight: 360 }}
      />
    </Box>
  );
};

export default TownPortalEmailEditor;
